import { Component, Input } from '@angular/core';
import { CoverageLegend } from './models/coverage-legend.model';

@Component({
    selector: 'coverage-legend',
    template: require('./coverage-legend.component.html')
})
export class CoverageLegendComponent {
    @Input() public legendsToShow: CoverageLegend[] = [];

    constructor() { }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/coverage-legend.component.ts